/**
 * Moves the cursor to the next field after `from`, the way Tab would, but only
 * onto things that take input: text fields, selects and the pickers
 * themselves (PersonPicker, EmployeeMultiSelect). Used once a single-choice
 * picker has its answer, so filling a form carries on without a click.
 *
 * Looks within the surrounding form or dialog, falling back to the page. Does
 * nothing when there is no next field.
 */
const FIELDS = [
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([disabled]):not([readonly])',
    'select:not([disabled])',
    'textarea:not([disabled]):not([readonly])',
    'button.pp-control:not([disabled])',
    '.ms-control[tabindex="0"]'
].join(', ');

export const focusNextField = (from) => {
    if (!from) return;
    const scope = from.closest('form, [role="dialog"], .msgr-modal, .swal2-popup') || document.body;
    const next = Array.from(scope.querySelectorAll(FIELDS)).find((el) => (
        !from.contains(el)
        // eslint-disable-next-line no-bitwise
        && (from.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)
        && el.getClientRects().length > 0
    ));
    next?.focus();
};

export default focusNextField;
